import React from 'react';
import { Container, Title, Table } from './styled';

const ReadyPlayer = ({ data }) => {
  return (
    <Container>
      <Title>후보</Title>
      <Table>
        <colgroup>
          <col width={150} />
          <col width={70} />
          <col width={70} />
          <col width={70} />
          <col width={70} />
          <col width={70} />
          <col width={70} />
          <col width={70} />
        </colgroup>
        <thead>
          <tr>
            <th>선수명</th>
            <th>포지션</th>
            <th>출장시간</th>
            <th>득점</th>
            <th>어시스트</th>
            <th>리바운드</th>
            <th>스틸</th>
            <th>블록</th>
          </tr>
        </thead>
        <tbody>
          {data.map((value, key) => {
            const {
              player,
              assistsAverage,
              blockedShotsAverage,
              pointsAverage,
              reboundsTotalAverage,
              stealsAverage,
              timesPlayedAverage
            } = value;
            return (
              <tr key={key}>
                <td>{player.displayName}</td>
                <td>{player.position}</td>
                <td>{timesPlayedAverage}</td>
                <td>{pointsAverage}</td>
                <td>{assistsAverage}</td>
                <td>{reboundsTotalAverage}</td>
                <td>{stealsAverage}</td>
                <td>{blockedShotsAverage}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
};

export default ReadyPlayer;
